module.exports = __webpack_public_path__ + "static/media/News-1.455d6a83.jpg";